import * as Yup from 'yup';

export const HireDispatcherSchema = Yup.object().shape({
    startDate: Yup.string().required('Start date is required'),
    phoneNumber: Yup.string().required('Phone number is required'),
    profilePicture: Yup.array()
        .required('Profile picture is required')
        .min(1, 'Please upload a profile picture'),
    address: Yup.string().required('House address is required'),
    // assignedVehicle: Yup.string().required('Vehicle assignment is required'),
    // plateNumber: Yup.string().required('Plate number is required'),
    employmentType: Yup.string().required('Employment type is required'),
});

export type HireDispatcherDataType = Yup.InferType<typeof HireDispatcherSchema>;

type InitialValues = {
    startDate: string;
    phoneNumber: string;
    profilePicture: File[];
    address: string;
    // plateNumber: string;
    employmentType: string;
};

export const HireDispatcherInitialValues: InitialValues = {
    startDate: '',
    phoneNumber: '',
    profilePicture: [],
    address: '',
    // plateNumber: '',
    employmentType: '',
};

export interface HireDispatcherInterface {
    startDate: string;
    phoneNumber: string;
    profilePicture: File[];
    address: string;
    // plateNumber: string;
    employmentType: string;
}
